<script>
import { mapState, mapGetters, mapActions } from "vuex";

import countdownMixin from "@/mixins/countdownMixin";
import moment from "@/utils/moment";

import Card from "../ProfessionalList/Card/Index";
import Empty from "./Empty";
import ProgressBar from "@/components/_base/ProgressBar";

export default {
  mixins: [countdownMixin],

  components: {
    Card,
    ProgressBar,
    Empty
  },

  methods: {
    ...mapActions("orderScheduler", ["setOrderOfferExpired"]),

    onTimeout() {
      this.setOrderOfferExpired();
    }
  },

  computed: {
    ...mapState("orderScheduler", [
      "preloader",
      "professionalId",
      "orderOfferCreatedAt",
      "orderOfferExpired"
    ]),
    ...mapGetters("orderScheduler", ["avaliableProfessionals"])
  },

  async mounted() {
    this.startCountDown(this.orderOfferCreatedAt, 600, moment().unix());
  }
};
</script>

<template>
  <div class="professional-list">
    <div class="header">
      <div class="left">
        <p>Buscando profissionais perto de você</p>
      </div>

      <div class="right" v-if="!orderOfferExpired">
        <span class="text">TEMPO RESTANTE</span>

        <div class="countdown">
          <div v-if="time">
            <span>{{ time }}</span>

            <ProgressBar :progress="percentageTimeLeft()" />
          </div>
        </div>
      </div>
    </div>

    <Empty v-if="!avaliableProfessionals.length" />

    <div v-if="avaliableProfessionals.length"  class="list">
      <Card
        v-for="professional in avaliableProfessionals"
        :key="professional.id"
        :professional="professional"
        :shouldApplyFocus="Boolean(professionalId)"
        :isSelected="professional.id === professionalId"
      />
    </div>

    <p v-if="avaliableProfessionals.length && orderOfferExpired" class="expired-offer">
      Esses são os profissionais que aceitaram realizar a limpeza.
    </p>
  </div>
</template>

<style scoped>
.professional-list {
  position: relative;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left {
  width: 65%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
}

.header > .left > img {
  width: 36px;
  height: 36px;
  margin-right: 8px;
  border-radius: 50%;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.right > .text {
  font-size: 10px;
  font-weight: 500;
  text-align: end;
}

.right > .countdown {
  font-size: 16px;
  font-weight: 500;
}

.list > *:not(:first-child) {
  margin-top: 8px;
}

.expired-offer {
  text-align: center;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/Index.vue